require('./adGenerator/adGenerator');
require('./passManager/passManager');
require('./rosters/rosters');
require('./teamInfoManager/teamInfoManager');
require('./broadcastManager/broadcastManager');
require('./reports/reports');
require('./videoAnalysis/videoAnalysis');

"use strict";

angular.module('app.admin', [
  'app.admin.adGenerator',
  'app.admin.passManager',
  'app.admin.rosters',
  'app.admin.teamInfoManager',
  'app.admin.broadcastManager',
  'app.admin.reports',
  'app.admin.videoAnalysis'
])
    .config([
      '$stateProvider',
      function ($stateProvider) {
        $stateProvider.state('app.admin', {
          abstract: true,
          url: '/admin',
          template: '<div ui-view class="admin"></div>'
        });
      }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/admin.js